import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { micIcon } from '../../../../assets/images/images';
import { SpeechToTextStatus } from '../../../../hooks/useSpeechToText';

type ChatMicButtonProps = {
  status: SpeechToTextStatus;
  onClick: () => void;
  disabled?: boolean;
};

/**
 * Mic control for chat textarea — records, then Whisper STT fills the input.
 * Mirrors the paperclip control (img + OverlayTrigger render tooltip).
 */
const ChatMicButton = ({ status, onClick, disabled }: ChatMicButtonProps) => {
  const isRecording = status === 'recording';
  const isTranscribing = status === 'transcribing';
  const isBusy = disabled || isTranscribing;
  const label = isTranscribing
    ? 'Transcribing…'
    : isRecording
      ? 'Stop recording'
      : 'Voice input';

  const renderMicTooltip = (props: any) => (
    <Tooltip id="chat-mic-tooltip" {...props}>
      {label}
    </Tooltip>
  );

  return (
    <OverlayTrigger
      placement="top"
      delay={{ show: 250, hide: 400 }}
      overlay={renderMicTooltip}
    >
      <img
        src={micIcon}
        alt={label}
        className={`chat-mic-btn ${isRecording ? 'is-recording' : ''} ${isBusy ? 'is-disabled' : ''}`}
        onClick={isBusy ? undefined : onClick}
        role="button"
        aria-label={label}
        aria-pressed={isRecording}
        aria-disabled={isBusy}
      />
    </OverlayTrigger>
  );
};

export default ChatMicButton;
